@if (pagingContext(); as ctx) {
  <ng-container *cftI18n="let t">
    <button class="btn text-xs text-primary" [disabled]="ctx.currentPage === 1" (click)="previous()">
      <fa-icon [icon]="pageLeftIcon"></fa-icon>
    </button>
    @if (ctx.showPageNumbers) {
      <span class="text-sm">
        @for (page of ctx.pages; track page) {
          <span
            [ngClass]="{'bg-grey-700 text-white': ctx.currentPage === page}"
            class="m-2xs inline-flex h-xl w-lg cursor-pointer items-center justify-center rounded-1"
            (click)="go(page)"
          >
            <span>{{ page }}</span>
          </span>
        }
        @if (ctx.pagesOutsideVisiblePageRange) {
          <span class="m-2xs h-xl w-lg">...</span>
        }
      </span>
    } @else {
      <span>
        {{ ctx.total ? ctx.pageOffset + 1 : 0 }} -
        {{ ctx.pageOffset + ctx.pageSize >= ctx.total ? ctx.total : ctx.pageOffset + ctx.pageSize }}
        <span class="font-normal">{{ t('paginationCounterOfLabel') }}</span> {{ ctx.total }}
      </span>
    }
    <button class="btn text-xs text-primary" (click)="next()" [disabled]="ctx.currentPage === ctx.numberOfPages">
      <fa-icon [icon]="pageRightIcon"></fa-icon>
    </button>
  </ng-container>
}
